import { Typography } from "@mui/material";
import DeleteIco from "../../../assets/icons/DeleteIco";
import UploadFileIco from "../../../assets/icons/UploadFileIco";
import CommonButton from "../../../component/Button";
import CommonTextField from "../../../component/Input";
import { HandleSkeletion } from "../../../utils/constants";
import { CustomDiv } from "../../chat-bot/style";
import { CommonGrid2 } from "../../common-components/StyledComponents";
import { CustomizeSpan } from "../style";

const QuestionsSection = ({
  title,
  icon,
  data,
  handleAnswerChange,
  addQuestion,
  loading,
  setAddQuestion,
  editable = false,
  datatype,
  isSuggested = false,
  setDeleteConfirm,
}) => {
//   if (!data?.length) return null;

  return (
    <CommonGrid2 padding={"1.5rem 0px 0px 0px"}>
      <CustomDiv
        width="100%"
        display="flex"
        gap="0.5rem"
        customStyle={{
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <CustomDiv
          display="flex"
          gap="0.5rem"
          customStyle={{
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {icon}
          <Typography variant="h5">{title}</Typography>
        </CustomDiv>
        {isSuggested && (
          <CommonGrid2
            width={"max-content"}
            display={"flex"}
            alignItems={"center"}
            gap={"1rem"}
            justifyContent={"center"}
          >
            <CommonButton
              value={"Upload recording file to Transcribe"}
              padding={"8px 16px"}
              variant="outlined"
              fontSize={"14px"}
              fontWeight={600}
              color="#344054"
              startIcon={<UploadFileIco />}
              gap={"0px"}
              disabled={true}
            />
            <CommonButton
              value={"+ Add Question"}
              padding={"8px 16px"}
              fontSize={"14px"}
              fontWeight={600}
              onClick={() =>
                setAddQuestion((prev) => ({ ...prev, open: true }))
              }
              disabled={!editable}
            />
          </CommonGrid2>
        )}
      </CustomDiv>

      {loading
        ? Array.from({ length: 3 }).map((_, index) => (
            <HandleSkeletion
              key={index}
              height="50px"
              width="100%"
              marginBottom="1rem"
            />
          ))
        : data.map((item, index) => (
            <CommonGrid2
              key={index}
              width="100%"
              border="1px solid rgba(0, 0, 0, 0.12)"
              background="#fff"
              borderRadius="10px"
              height="fit-content"
              padding="1rem"
              marginTop="1rem"
            >
              <CommonGrid2
                display={"flex"}
                flexDirection={"row"}
                alignItems={"center"}
                justifyContent={"space-between"}
                gap={"1rem"}
                paddingBottom="0.5rem"
              >
                <Typography variant="body2" fontWeight={600}>
                  {index + 1}. {item.question}
                </Typography>
                {editable && (
                  <CustomDiv
                    onClick={() => setDeleteConfirm({ open: true, index: index, data: data, datatype:datatype })}
                    customStyle={{
                      cursor: "pointer",
                    }}
                  >
                    <DeleteIco stroke="#D80027" />
                  </CustomDiv>
                )}
              </CommonGrid2>

              <CustomDiv
                background={isSuggested ? "#FFFFFF" : "#F6F8FB"}
                padding="0.5rem"
                border={isSuggested ? "1px solid rgba(0, 0, 0, 0.12)" : "none"}
                borderRadius="5px"
                display="flex"
                alignItems="center"
                gap="0.5rem"
                color="#00144A"
              >
                <CustomizeSpan
                  fontWeight={700}
                  color="#00144A"
                  fontSize={"14px"}
                >
                  Answer:
                </CustomizeSpan>

                <CommonTextField
                  defaultValue={item.answer}
                  fontSize={"14px"}
                  read={!editable}
                  padding="0px"
                  border="none"
                  background="#F6F8FB"
                  borderRadius="5px"
                  multiline={true}
                  customStyle={{
                    width: "100%",
                    "& input.Mui-readOnly": {
                      borderRight: "0px solid #D0D5DD",
                    },
                    "& .MuiInputBase-root": {
                      padding: "0px",
                    },
                  }}
                  value={item.answer}
                  onChange={(e) => handleAnswerChange(e, index, data, datatype)}
                  placeholder={"Enter answer here..."}
                />
              </CustomDiv>
            </CommonGrid2>
          ))}
    </CommonGrid2>
  );
};

export default QuestionsSection;
